import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl, FormControlLabel, Grid, InputAdornment,
    InputLabel, MenuItem, Select, Switch,
} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import {gql} from "@apollo/client";
import LoadingDialog from "../../components/loadingDialog";
import {mutate} from "../../lib/apollo";
import TextField from "@mui/material/TextField";
import SingleSelect from "../../components/SingleSelect";

export default function CostQueueUpsert (params: {costQueue: any, setOpen: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);
    const [notes, setNotes] = React.useState('' as string);
    const [active, setActive] = React.useState<boolean>(true);
    const [cost, setCost] = React.useState(0);

    React.useEffect(() => {
        if (params.costQueue && params.costQueue.id) {
            setNotes(params.costQueue.notes);
            setActive(params.costQueue.active);
            setCost(params.costQueue.cost);

        } else {
            setNotes("");
            setActive(true);
            setCost(0);
        }
    }, [params.costQueue]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason == "backdropClick")
            return;
        params.setOpen(null);
    };

    const handleSubmit = async (event: any) => {
        let q;
        let variables;
        let good = false;
        let input = {
            active,
            cost,
            notes
        }
        if (isEdit) {
            q = gql`
                mutation m($id: Int!, $input: CostQueueWrite!) {
                    costQueueUpdate(id: $id, input: $input)
                }
            `;

            variables = {
                id: params.costQueue.id,
                input
            };

            setLoading(true);

            const res = await mutate(q, variables);
            good = res && res.costQueueUpdate;
        } else {
            q = gql`
                    mutation m($input: CostQueueWrite!) {
                        costQueueCreate(input: $input)
                    }
                `;

            variables = {
                input
            };

            setLoading(true);

            const res = await mutate(q, variables);
            good = res && res.costQueueCreate;
        }

        if (good) {
            toast.success(isEdit ? 'Cost updated successfully' : 'Cost added successfully');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }

    }

    if (!params.costQueue) return <> </>;

    const isEdit = !!params.costQueue.id;

    return (
        <>
                <Dialog
                    open={!!params.costQueue}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'sm'}
                    fullWidth={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        {isEdit ? 'Update Cost' : 'Add Cost'}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="notes"
                                    label="Notes"
                                    type="text"
                                    fullWidth
                                    size={'small'}
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={6}>
                                <TextField
                                    autoComplete={'off'}
                                    margin="dense"
                                    id="cost"
                                    label="Amount"
                                    type="number"
                                    fullWidth
                                    size={'small'}
                                    value={cost}
                                    onChange={(e) => setCost(parseFloat(e.target.value))}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <FormControlLabel control={<Switch checked={active} onChange={(event)=> setActive(event.target.checked)} />} label={"Active"} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    {loading ? <LoadingDialog/> :
                    <DialogActions>
                        <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                        <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>
                            {isEdit ? `Update` : 'Add'}
                        </Button>
                    </DialogActions>
                    }
                </Dialog>
        </>
    )
}
